import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import AlertasMantenimiento from './AlertasMantenimiento';
import Lottie from 'lottie-react';
import mantenimiento from './mantenimiento-vehiculos.json';

const MantenimientoVehiculos = () => {
    const [alertas, setAlertas] = useState([]);
    const [historial, setHistorial] = useState([]);
    const [vehiculos, setVehiculos] = useState([]);

    // Cargar vehículos
    useEffect(() => {
        const fetchVehiculos = async () => {
            try {
                const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/vehiculos/');
                const data = await response.json();
                setVehiculos(data);
            } catch (error) {
                console.error("Error cargando vehículos:", error);
            }
        };
        fetchVehiculos();
    }, []);

    // Cargar alertas
    useEffect(() => {
        const fetchAlertas = async () => {
            try {
                const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/alertas/');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();

                const alertasTransformadas = data.map(alerta => ({
                    id: alerta.id,
                    vehiculo_id: alerta.vehiculo,
                    tipo_mantenimiento: alerta.tipo_mantenimiento,
                    descripcion: alerta.descripcion,
                    fecha_programada: alerta.fecha_programada,
                    realizada: alerta.realizada,
                    // Agregar los nuevos campos del serializer
                    vehiculo_placa: alerta.vehiculo_placa,
                    porcentaje_avance: alerta.porcentaje_avance,
                    kilometraje_actual: alerta.kilometraje_actual,
                    estado_alerta: alerta.estado_alerta,
                    proximo_mantenimiento_kms: alerta.proximo_mantenimiento_kms,
                    km_faltantes: alerta.km_faltantes
                }));

                setAlertas(alertasTransformadas);
            } catch (error) {
                console.error('Error fetching alertas:', error);
            }
        };
        fetchAlertas();
    }, []);

    // Función auxiliar para obtener nombre del vehículo
    const getNombreVehiculo = (vehiculo_id) => {
        const vehiculo = vehiculos.find(v => v.id === vehiculo_id);
        return vehiculo ? `${vehiculo.marca} ${vehiculo.modelo} (${vehiculo.placa})` : 'Desconocido';
    };

    return (
        <Box sx={{ width: '95%', p: 3 }}>
            {/* Encabezado */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="h4" fontWeight="bold">Mantenimiento de vehículos</Typography>
            </div>
            
            {/* Animación Lottie */}
            <Box sx={{ 
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '200%' 
            }}>
                <Lottie
                    animationData={mantenimiento}
                    loop={true}
                    autoplay={true}
                    style={{ 
                        width: 180, 
                        height: 180,  
                        justifyContent: 'center',
                        alignItems: 'center' 
                    }}
                />
            </Box>

            {/* Componente de Alertas */}
            <AlertasMantenimiento
                vehiculos={vehiculos}
                alertas={alertas}
                setAlertas={setAlertas}
                historial={historial}
                setHistorial={setHistorial}
                getNombreVehiculo={getNombreVehiculo}
            />
        </Box>
    );
};

export default MantenimientoVehiculos;